module.exports = __webpack_public_path__ + "dec904214b33da93c3c7511216bc7326.pdf";